export default "__VITE_ASSET__586ec06b__"